// pipes/custom-date.pipe.ts
import { computed, inject, Pipe, PipeTransform } from '@angular/core';
import { PLATFORM_CONFIG, PlatformConfig } from '@platform/config';
import moment from 'moment-jalaali';
import { I18nService } from '../..';

@Pipe({
    name: 'customDate',
    standalone: true // Remove if using NgModule
})
export class CustomDatePipe implements PipeTransform {
    private readonly i18n = inject(I18nService);
    currentLocale = computed(() => this.i18n.getCurrentLocale());
    protected readonly config = inject<PlatformConfig>(PLATFORM_CONFIG);

    transform(
        value: string | Date | null | undefined,
        gregorianFormat: string = 'yyyy-MM-dd',
        jalaliFormat: string = 'jYYYY/jMM/jDD',
    ): string {

        if (!value) {
            return '';
        }

        const currentLocal = this.currentLocale() || this.config.i18n.defaultLocale;
        // Parse the input date
        const date = moment(value);

        if (!date.isValid()) {
            return '';
        }

        if (currentLocal === 'fa') {
            // Persian/Jalali date
            return date.format(jalaliFormat);
        } else {
            // Gregorian date - map Angular date format to moment format if needed
            const momentFormat = this.mapAngularToMomentFormat(gregorianFormat);
            return date.format(momentFormat);
        }
    }

    /**
     * Maps Angular date pipe format to moment.js format
     */
    private mapAngularToMomentFormat(angularFormat: string): string {
        const mapping: { [key: string]: string } = {
            'yyyy': 'YYYY',
            'yy': 'YY',
            'MM': 'MM',
            'M': 'M',
            'dd': 'DD',
            'd': 'D',
            'HH': 'HH',
            'H': 'H',
            'mm': 'mm',
            'm': 'm',
            'ss': 'ss',
            's': 's',
            'EEE': 'ddd',
            'EEEE': 'dddd',
        };

        let momentFormat = angularFormat;
        for (const [angular, moment] of Object.entries(mapping)) {
            momentFormat = momentFormat.replace(new RegExp(angular, 'g'), moment);
        }

        return momentFormat;
    }
}